import { render, staticRenderFns } from "./BaseInputPriceDepositMoney.vue?vue&type=template&id=240c62ce&"
import script from "./BaseInputPriceDepositMoney.vue?vue&type=script&lang=js&"
export * from "./BaseInputPriceDepositMoney.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputPriceDepositMoney.vue?vue&type=style&index=0&id=240c62ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports